import React, { useCallback, useMemo, useState, useRef } from 'react';
import Form, { SimpleItem, GroupItem, Label, RequiredRule } from 'devextreme-react/form';
import { useDispatch, useSelector } from 'react-redux'
import { createStoreLocal } from '../../utils/proxy';
import { editorOptionsSelect, formatDate } from '../../data/app';
import { DataGrid, Button, SelectBox } from 'devextreme-react';
import { Column, Editing, Lookup, RequiredRule as RuleRequired, Button as ButtonGrid, Summary, TotalItem } from 'devextreme-react/data-grid';
import { cellRender, formatToMoney, toMoney } from '../../utils/common';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { billDefault, defaultLabels } from '../../data/defaultObjects';
import ProductDDBComponent from '../../components/dropdown/ProductDDBComponent';
import useProducts from '../../hooks/useProducts';
import uri from '../../utils/uri';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import Resumen from '../../components/form/Resumen';
import DataSource from 'devextreme/data/data_source';
import ItemRender from '../../components/grids/ItemRender';
import { preBillType } from '../../data/enums';

const NuevoQuickly = props => {

    const { user, appInfo } = useSelector(store => store);
    const isPreventa = true

    const { clientId } = appInfo

    const billDefaultCustom = { ...billDefault, clientId: clientId, paymentTypeId:1, nameClient: 'Cliente de contado', preBillTypeId: preBillType.preventa, preBillDetails: [] };

    const [reload, setReload] = useState(0);
    const { products } = useProducts({ areaId: user.areaId, exists: true, reload });
    const [bill, setBill] = useState({ ...billDefaultCustom });
    const [saving, setSaving] = useState(false);
    const [resumenData, setResumenData] = useState([]);

    let refForm = useRef();
    let refGrid = useRef();
    let textBoxRef = useRef();
    let refSelect = useRef(); 

    const dispatch = useDispatch();
    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar articulo',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => refGrid.current.instance.addRow()
            }
        });
    }

    const guardarFactura = (e) => {

        refGrid.current.instance.saveEditData();
        let result = refGrid.current.instance.hasEditData();

        if (!result) {

            result = refForm.current.instance.validate();

            if (result.isValid) {

                setSaving(true);
                let data = { ...bill, clientId: appInfo.clientDefault };

                http(uri.prebills.insert).asPost(data).then(resp => {

                    setSaving(false);
                    notify(`Factura registrada correctamente`);
                    setBill({ ...billDefaultCustom });
                    setResumenData([]);
                    setReload(Math.random());
                    //routeReset(props);

                }).catch(err => {
                    setSaving(false);
                    notify(err, 'error', 5000);
                });

            }
        }

    }

    const setCellValue = (prop, newData, value, currentRowData) => {

        newData[prop] = value || 0;
        if (prop == 'productId' && value) {

            let info = products.find(x => x.id == value);
            newData['presentation'] = info.presentation;
            newData['um'] = info.um;
            newData['family'] = info.family;
            newData['stock'] = info.stock;
            newData['price'] = info.price;
            newData['customPrice'] = info.price;
            newData['cost'] = info.cost;
            newData['discount'] = 0;
            newData['discountUnit'] = 0;
            newData['discountPercent'] = 0;
            !currentRowData['quantity'] && (newData['quantity'] = 1);
            !currentRowData['total'] && (newData['total'] = info.price);
        }

        if (prop == 'quantity' && (+value) >= 0) {
            const stock = currentRowData['stock'] + value;
            if (value > stock && isPreventa) {
                newData['quantity'] = currentRowData['stock'];
                newData['total'] = currentRowData['customPrice'] * currentRowData['stock'];
                notify(stock + " máximo stock disponible", "error", 5000);
            } else {
                newData['total'] = currentRowData['customPrice'] * value;
            }
        }

        if (prop == 'customPrice' && (+value) >= 0) {
            newData['total'] = currentRowData['quantity'] * value;
        }

        if (prop == 'discountUnit' && (+value) >= 0) {
            newData['discount'] = value * currentRowData['quantity'];
            newData['total'] = (currentRowData['quantity'] * currentRowData['customPrice']) - newData['discount'];
            newData['discountPercent'] = parseFloat((newData['discount'] * 100) / (currentRowData['quantity'] * currentRowData['customPrice'])).toFixed(6);
        }

        if (prop == 'discount' && (+value) >= 0) {
            newData['total'] = (currentRowData['quantity'] * currentRowData['customPrice']) - value;
            newData['discountPercent'] = parseFloat((value * 100) / (currentRowData['quantity'] * currentRowData['customPrice'])).toFixed(6);
            newData['discountUnit'] = parseFloat(value / currentRowData['quantity']).toFixed(4);
        }

        if (prop == 'discountPercent' && (+value) >= 0) {
            newData['discount'] = parseFloat((currentRowData['quantity'] * currentRowData['customPrice']) * (value / 100)).toFixed(6);
            newData['total'] = (currentRowData['quantity'] * currentRowData['customPrice']) - newData['discount'];
            newData['discountUnit'] = parseFloat(newData['discount'] / currentRowData['quantity']).toFixed(6);

        }

    }

    // useEffect(() => {
    //     if (appInfo.rate == 0) {
    //         notify('Debe ingresar la tasa de cambio del dia para poder facturar', 'warning', 5000)
    //         props.history.push('/app/tasa-de-cambio');
    //     }
    // }, [appInfo]);

    const onCellPrepared = e => {

        const cellsQuantity = ['quantity', 'quantityRequest']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                e.cellElement.classList.add('quantity-text');
            if (e.column.dataField == 'customPrice')
                e.cellElement.classList.add('customPrice-text');
        }

    }

    const onKeyDown = (e) => {

        if (e?.event?.key == 'Enter') {

            const code = e.event.target.value;

            let info = products.find(x => x.internalCode == code);
            let newData = {};


            newData['presentation'] = info.presentation;
            newData['um'] = info.um;
            newData['family'] = info.family;
            newData['price'] = info.price;
            newData['customPrice'] = info.price;
            newData['cost'] = info.cost;
            newData['quantity'] = 1;
            newData['total'] = info.price;
            newData['discount'] = 0;
            newData['productId'] = info.id;

            const newDetail = [...bill.preBillDetails, newData];

            setBill({ ...bill, preBillDetails: [...newDetail] });
            setResumenData([...newDetail]);

        }

    }

    const onRowInserted = e => {
        setResumenData([...bill.preBillDetails])
    }

    const title = 'Nueva pre-factura';

    const init = "";

    // useEffect(() => {

    //    http('catalogos/lots').asGet().then(_lots => {
    //      const lotsMap = _lots.map(x => ({ ...x, name: `${x.lote}-${moment(x.expireDate).format('DD-YYYY')}` }));
    //      setLots(lotsMap);
    //    });

    // },[reload]);

    // useEffect(() => {

    //     window.addEventListener("beforeunload", alertUser);
    //     return () => {
    //     window.removeEventListener("beforeunload", alertUser);
    //     };
    // }, []);

    const dataSourceProduct = useCallback(() => new DataSource({
        load: (loadOptions) => {
    
            let params = {};
            params.skip = loadOptions.skip || 0;
            params.take = loadOptions.take || 10;
    
            if(loadOptions.searchValue)
                params.name = loadOptions.searchValue;

            params.exists = true;
            params.active=false; 
            params.has=false;
            params.onlyProducts= false;
    
            return http(uri.products.getByArea(user.areaId)+'/grid')
            .asGet(params).then(x => x.items);
            
        },
        byKey: id => http(uri.products.getById(id)).asGet(),
        paginate : true,
        pageSize: 10
    }),[]);

    const addProductById = ( id, _info=null ) => {

        if (!id) return;

        const items = ds.items();

        const existsProduct = items.find(x => x.productId == id);

        if (existsProduct) {
            notify(`El producto ya se encuentra en la lista`, 'error', 5000);
            return
        }

        let info = _info == null ? products.find(x => x.id == id) : _info;

        if(info.stock <= 0)
            return notify('No hay stock disponible', 'error', 5000);

        let newData = {}; 

        newData['presentation'] = info.presentation;
        newData['um'] = info.um;
        newData['family'] = info.family;
        newData['stock'] = info.stock;
        newData['price'] = info.price;
        newData['customPrice'] = info.price;
        newData['cost'] = info.cost;
        newData['quantity'] = 1;
        newData['total'] = info.price;         
        newData['discount'] = 0;
        newData['discountUnit'] = 0;
        newData['discountPercent'] = 0;
        newData['productId'] = info.id;  

        ds.store().insert(newData).then(() => {
            ds.reload().then(() => {
                refGrid.current.instance.editCell(bill.preBillDetails.length - 1, 'quantity');
            });
        });

        //setBill(_bill => ({ ..._bill, billDetails: [...newDetail],}));

    }

    const alertUser = (e) => {
        e.preventDefault();
        e.returnValue = "";
        alert('saliendo');
    };

    const ds = useMemo(() => new DataSource({
        key: 'productId',
        store: bill.preBillDetails,
        // ...
    }));

    const setFocus = () => {
        setTimeout(() => {
            refSelect.current.instance.focus();        
        }, 300);
    }

    const onEditCanceled = (e) => {
        setFocus()
    }

    const keyDown = (e) => {
        if(e.event.key == 'Enter')
            setFocus()
    }

    return (
        <div className="container medium">
            <Title title={title} />
            <BlockHeader title={title} />
            <Form formData={bill} ref={refForm}>
                <GroupItem colCount={3}>
                    <GroupItem colSpan={2}>
                        <GroupItem colCount={3}>

                            <SimpleItem dataField="date" editorType="dxDateBox"
                                editorOptions={{
                                    displayFormat: formatDate,
                                    disabled: true
                                }} >
                                <Label text="Fecha" />
                                <RequiredRule message="Seleccione la fecha" />
                            </SimpleItem>
                            <SimpleItem dataField="paymentTypeId" editorType="dxSelectBox"
                                editorOptions={{
                                    dataSource: createStoreLocal({ name: 'billPaymentType' }),
                                    ...editorOptionsSelect,
                                    disabled: true
                                }} >
                                <Label text="Pago" />
                                <RequiredRule message="Seleccione el tipo" />
                            </SimpleItem>
                            <SimpleItem dataField="reference" colSpan={2} editorType="dxTextBox"
                                editorOptions={{ placeholder: 'Factura No', showClearButton: true }} >
                                <Label text="Referencia" />
                            </SimpleItem>
                            <SimpleItem dataField="nameClient" colSpan={3} editorType="dxTextBox"
                                editorOptions={{ placeholder: 'Cliente de contado', showClearButton: true }} >
                                <Label text="Cliente" />
                            </SimpleItem>

                        </GroupItem>
                    </GroupItem>
                    <GroupItem colSpan={1}>
                        <Resumen data={resumenData} />
                    </GroupItem>

                </GroupItem>
                <GroupItem colCount={4}>
                    <SimpleItem colSpan={2}>
                        <SelectBox
                            ref={refSelect}
                            dataSource={dataSourceProduct()}
                            valueExpr="id"
                            displayExpr={item => item ? `${item.internalCode} - ${item.name}` : ''}
                            searchEnabled={true}
                            //disabled={!editing && !currentIsCotizazion}
                            searchMode="contains" searchExpr={['name', 'internalCode']}
                            searchTimeout={600}
                            placeholder="Selecione una producto"
                            showClearButton={true}
                            itemRender={ItemRender}
                            onValueChanged={e => {

                                addProductById(e.value);
                                e.component.reset();
                                e.component.focus();

                            }} />
                    </SimpleItem>
                </GroupItem>
                <GroupItem>
                    <DataGrid id="gridDetails"
                        ref={refGrid}
                        selection={{ mode: 'single' }}
                        dataSource={ds}
                        showBorders={true}
                        showRowLines={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        height={290}
                        onToolbarPreparing={onToolbarPreparing}
                        onRowInserted={onRowInserted}
                        onRowRemoved={onRowInserted}
                        onRowUpdated={onRowInserted}
                        onCellPrepared={onCellPrepared}
                        onEditCanceled={onEditCanceled}                              
                        onKeyDown={keyDown}
                    >
                        <Column dataField="productId" caption="Producto"
                            setCellValue={setCellValue.bind(null, "productId")}
                            editCellComponent={props => <ProductDDBComponent showPrice={true} {...props} validateQuantity={true} />}
                        >
                            <Lookup
                                dataSource={products}
                                valueExpr="id"
                                displayExpr={item => item ? `${item.internalCode} - ${item.name}` : ''}

                            />
                            <RuleRequired />
                        </Column>
                        <Column dataField="family" caption={defaultLabels.family} width={120} allowEditing={false}>
                            <RuleRequired />
                        </Column>
                        <Column dataField="quantity" caption="Cantidad" dataType="number" width={80}
                            setCellValue={setCellValue.bind(null, "quantity")}
                        >
                            <RuleRequired />
                        </Column>
                        <Column dataField="stock" caption="Disponible" dataType="number" width={90} allowEditing={false}>
                        </Column>
                        <Column visible={false} dataField="price" caption="Precio" dataType="number" width={100} allowEditing={false} cellRender={cellRender()} >
                            <RuleRequired />
                        </Column>
                        <Column dataField="customPrice" caption="Precio" dataType="number" width={100} cellRender={cellRender()}
                            setCellValue={setCellValue.bind(null, "customPrice")}>
                            <RuleRequired />
                        </Column>
                        <Column dataField="discountUnit" caption="Desc Uni" dataType="number" width={80} cellRender={cellRender()}
                            setCellValue={setCellValue.bind(null, "discountUnit")}>
                            <RuleRequired />
                        </Column>
                        <Column dataField="discountPercent" caption="Desc %" dataType="number" width={80}
                            setCellValue={setCellValue.bind(null, "discountPercent")}>
                            <RuleRequired />
                        </Column>
                        <Column dataField="discount" caption="Desc" dataType="number" width={80} cellRender={cellRender()}
                            setCellValue={setCellValue.bind(null, "discount")}>
                            <RuleRequired />
                        </Column>
                        <Column dataField="total" caption="Total" dataType="number" width={120} allowEditing={false} cellRender={cellRender()} >
                            <RuleRequired />
                        </Column>
                        <Column type="buttons" width={50}>
                            <ButtonGrid name="delete" />
                        </Column>
                        <Summary>
                            <TotalItem column="productId" summaryType="count" />
                            <TotalItem column="discount" summaryType="sum" customizeText={toMoney} />
                            <TotalItem
                                column="total"
                                summaryType="sum"
                                customizeText={data => formatToMoney(data.value)} />
                        </Summary>
                        <Editing
                            mode="cell"
                            allowDeleting={true}
                            allowUpdating={true}
                            selectTextOnEditStart={true}
                            useIcons={true}
                        ></Editing>
                    </DataGrid>
                </GroupItem>
            </Form>
            <Button
                className="mt-10"
                text={saving ? 'Guardando...' : `Guardar pre-factura`}
                type="success"
                icon='save'
                disabled={saving}
                onClick={guardarFactura}
            />


        </div>
    );
}

export default NuevoQuickly;
